"use strict";
require("es6-promise").polyfill();
module.exports = require("./cjs/request.cjs.js");
